export default __webpack_public_path__ + "static/media/use.5ecf90c5.svg";